import * as React from 'react'
import './testimonies.css'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'

export default class Testimonies extends React.Component<any> {
  constructor(props: any) {
    super(props)
    this.state = {}
  }

  render() {
    const content = this.props.content
    return (
      <div>
        {content !== undefined &&
          Object.keys(content).map((key) => {
            return (
              <div key={key} className="testimonies-container">
                <div
                  className="testimonies-image"
                  style={{
                    backgroundImage: `url(${content[key].fields.mynd.fields.file.url})`,
                  }}
                />
                <div className="testimonies-text">
                  <h2>{content[key].fields.efriTexti}</h2>
                  <div
                    className="testimonies-text-content"
                    dangerouslySetInnerHTML={{
                      __html: documentToHtmlString(
                        content[0].fields.texti,
                      ).replace(/(?:\r\n|\r|\n)/g, '<br />'),
                    }}
                  />
                  <div className="customer-image">
                    <img
                      src={content[key].fields.einstaklingur.fields.file.url}
                    />
                    <div className="customer-name">
                      <strong>{content[key].fields.nafnEinstaklings}</strong>
                      <span>{content[key].fields.fyrirtki}</span>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/front-page/testimonies/testimonies.tsx